import { render, staticRenderFns } from "./SFormSettingBillComp.vue?vue&type=template&id=4ec909e3&"
import script from "./SFormSettingBillComp.vue?vue&type=script&lang=js&"
export * from "./SFormSettingBillComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports